import { render, staticRenderFns } from "./PatientManagement.vue?vue&type=template&id=57c842a8"
import script from "./PatientManagement.vue?vue&type=script&lang=js"
export * from "./PatientManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports